import { useTranslate } from '@tolgee/react';
import React, { useState } from 'react';
import { faTimes } from '@fortawesome/free-solid-svg-icons'; // Import the FontAwesome icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; // Import the FontAwesome component
import { useDispatch, useSelector } from 'react-redux';
import { updatePostDataKey } from '../../../../redux/slices/lomavisCreator/lomavisCreator';
import {
  FACEBOOK,
  LINKEDIN_BUSINESS_PAGE,
  LINKEDIN_PERSONAL_ACCOUNT
} from '../../../../config/constants';
import { URL_REGEX } from '../creatorTextEditor/config';

interface PreviewProps {
  title: string;
  description: string;
  image: string;
  url: string;
  domain: string;
  error?: boolean;
  platform;
}

const LinkPreview: React.FC<{
  data: PreviewProps;
  text: any;
  platform: any;
}> = ({ data, text, platform }) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const {
    postData: {
      [platform]: { show_preview_url, url_for_linkpreview }
    }
  } = useSelector((state: any) => state.lomavisCreator);
  const onClose = () => {
    dispatch(
      updatePostDataKey({ key: 'show_preview_url', platform, value: false })
    );
  };

  const closeButtonAvailableForPlatforms = [
    FACEBOOK,
    LINKEDIN_BUSINESS_PAGE,
    LINKEDIN_PERSONAL_ACCOUNT
  ];
  if (!url_for_linkpreview) return null;

  return (
    <div className="w-100 url-preview-wrapper position-relative">
      {/* "X" Button */}
      { show_preview_url &&
        closeButtonAvailableForPlatforms.includes(platform) && (
          <FontAwesomeIcon
            icon={faTimes}
            className="position-absolute top-0 end-0 p-2 cursor-pointer"
            onClick={onClose} // Hide the preview on click
          />
        )}
      {!show_preview_url &&
        closeButtonAvailableForPlatforms.includes(platform) && (
          <div
            className="d-flex flex-end justify-content-end text-dark cursor-pointer"
            onClick={() =>
              dispatch(
                updatePostDataKey({
                  key: 'show_preview_url',
                  platform,
                  value: true
                })
              )
            }
          >
            <span className="badge bg-light text-dark m-3">
              {t('lomavisCreator.urlPreview.showUrl')}
            </span>
          </div>
        )}
      {/* Loading State */}
      {!data && show_preview_url && (
        <div className="w-100 link-preview-loading-wrapper">
          <div className="w-100 bg-secondary text-center py-4">
            <div className="d-flex flex-column justify-content-center w-100">
              <div className="d-flex justify-content-center my-3">
                <div className="spinner-border text-dark" role="status">
                  <span className="sr-only">
                    {t('lomavisCreator.urlPreview.loading')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Error State */}
      {data?.error && show_preview_url && (
        <div className="w-100 bg-secondary">
          <div className="w-100 text-center py-4 rounded text-dark text-justify">
            {t('lomavisCreator.urlPreview.error')}
          </div>
        </div>
      )}

      {/* Link Preview */}
      {data && url_for_linkpreview && !data?.error && show_preview_url && (
        <div className="w-100 link-preview-wrapper">
          <div className="w-100 link-preview-image-wrapper">
            {data.image && (
              <img
                className="w-100 link-preview-image"
                src={data.image}
                alt={data.title}
              />
            )}
          </div>
          <div className="w-100 d-flex flex-column bg-light-secondary px-5 py-5">
            <div
              className="fw-bolder h4 mb-1 link-preview-title"
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {data.title}
            </div>
            <div
              className="link-preview-description"
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {data.description}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LinkPreview;
